import {
  ProjectFilesService,
  type ProjectFileResponseDto,
  type UpdateProjectFileDto,
} from '@inference.engine/workspace-api-client/web';
import { workspaceHttp } from '@/lib/api/http-client';
import { SUPPRESS_ERROR_NOTIFICATION_HEADER } from '@/lib/api/interceptors/problem-details.interceptor';

export const updateProjectFile = async (
  platformProjectId: string,
  fileId: string,
  data: UpdateProjectFileDto,
): Promise<ProjectFileResponseDto> => {
  const response = await ProjectFilesService.updateFile({
    client: workspaceHttp,
    path: { platformProjectId, fileId },
    body: data,
    // eslint-disable-next-line i18next/no-literal-string -- request header value, never rendered
    headers: { [SUPPRESS_ERROR_NOTIFICATION_HEADER]: 'true' },
  });

  if (!response.data) {
    throw new Error('Failed to update file');
  }

  return response.data;
};
